/**
 * Card detail wrapper.
 *
 * The route loader resolves the card (and legacy-slug redirects) on the server,
 * so the page renders real content in the server HTML instead of a skeleton.
 */

import { useNavigate } from "@/lib/router-compat";
import { Route } from "@/routes/kreditkarten/$slug";
import CardDetail from "@/pages/CardDetail";
import { DeclinedCard404DE } from "@/components/DeclinedCard404DE";

export default function CardDetailWrapper() {
  const navigate = useNavigate();
  const { card } = Route.useLoaderData();

  if (!card) {
    return <DeclinedCard404DE onNavigateHome={() => navigate('/')} />;
  }

  return <CardDetail initialCard={card} />;
}
